<template>
  <div class="study-view-template" theme>
    <div id="study-view-content" :class="{'show-video': showVideo, 'video-content-area': true}" />
    <div id="css-loading-checking-element" />
    <b-modal
      id="play-continue-confirm-modal"
      ref="playContinueConfirmModalRef"
      :title="$t('common.modal.title.confirm')"
      :ok-title="$t('common.button.ok')"
      :cancel-title="$t('common.button.cancel')"
      :lazy="true"
      :no-close-on-backdrop="true"
      @ok="continuePlay()"
      @cancel="initPlay()"
    >
      <p class="my-4" v-html="$t('player.modal.text.continue')" />
    </b-modal>
  </div>
</template>

<script>
import Vimeo from '@vimeo/player'
export default {
  data() {
    return {
      path: 'study',
      parts: [
        {
          elem: '#study-view-content',
          htmlFile: 'study-view'
        }
      ],
      videoType: undefined,
      showVideo: false
    }
  },
  watch: {
    '$route.query.goodsCompositionId': {
      handler(newVal, oldVal) {
        if (!newVal) {
          return
        }
        this.showVideo = false
        if (this.youtubeTimer) {
          clearInterval(this.youtubeTimer)
        }
        this.playHistId = undefined
        this.bgnTime = undefined
        this.endTime = undefined
        this.pt = undefined
        this.detailLoaded = false
        this.$axios
          .$get('/goods/public/goodsDetail?id=' + this.$route.query.goodsId)
          .then(response => {
            if (response.resultCode === 'success') {
              for (let i = 0; i < response.data.compositions.length; i++) {
                if (
                  parseInt(response.data.compositions[i].id) ===
                  parseInt(newVal)
                ) {
                  const composition = response.data.compositions[i]
                  this.currentComposition = response.data.compositions[i]
                  this.videoType = this.currentComposition.vidoTyCode
                  const headers = new Headers()
                  if (composition.vidoTyCode === 'video_type.youtube') {
                    headers.append('Content-Type', 'application/json')
                    headers.append('Accept', 'application/json')
                    let youtubeUrl = `https://www.googleapis.com/youtube/v3/videos?part=snippet,statistics&maxResults=50&key=AIzaSyCH58GjOqjLkVY84W14rELSfvqn2ikRGDg`
                    youtubeUrl += '&id=' + composition.vidoData
                    fetch(youtubeUrl, {
                      mode: 'cors',
                      method: 'GET',
                      headers: headers
                    }).then(res => {
                      res.json().then(result => {
                        if (
                          result &&
                          result.items &&
                          result.items.length > 0 &&
                          result.items[0].statistics
                        ) {
                          if (
                            '' + composition.rdcnt !==
                            result.items[0].statistics.viewCount + ''
                          ) {
                            const updateUrl =
                              'goods/viewCount?id=' +
                              composition.id +
                              '&viewCount=' +
                              result.items[0].statistics.viewCount
                            this.$axios.$put(updateUrl)
                          }
                          composition.rdcnt =
                            result.items[0].statistics.viewCount
                          this.$forceUpdate()
                        }
                      })
                    })
                  }
                  break
                }
              }
              this.detailLoaded = true
              this.initPlayer()

              this.$nextTick(() => {
                this.showVideo = true
                $('html').scrollTop(0)
              })
            } else {
              console.error(this.$t(response.message, response.params))
              this.$toast.error(this.$t(response.message, response.params))
            }
          })
      },
      immediate: true
    }
  },
  mounted() {
    if (!this.loggedInUser) {
      this.notLoggedIn()
      return
    }
    this.$eventHub.$on('youtube-loaded', this.onYoutubeLoaded)
  },
  async beforeDestroy() {
    if (this.youtubeTimer) {
      clearInterval(this.youtubeTimer)
    }
    if (this.player) {
      await this.player.destroy()
      this.player = undefined
    }
    this.$eventHub.$off('youtube-loaded', this.onYoutubeLoaded)
  },
  methods: {
    onVideoChanged(params) {
      if (this.componentId === parseInt(params.componentId)) {
        this.currentComposition = params.composition
        this.initPlayer()
      }
    },
    continuePlay() {
      if (this.player) {
        if (this.videoType === 'video_type.vimeo') {
          this.player.setCurrentTime(
            this.currentComposition.atnlc.lastPlayHist.endTime / 1000
          )
          this.player.play()
        } else if (this.videoType === 'video_type.youtube') {
          this.player.seekTo(
            this.currentComposition.atnlc.lastPlayHist.endTime / 1000
          )

          if (this.bgnTime === undefined) {
            this.bgnTime = this.currentComposition.atnlc.lastPlayHist.endTime
          }
          this.player.playVideo()
        }
        setTimeout(function() {
          $('html').scrollTop(0)
        }, 500)
      }
    },
    initPlay() {
      if (this.player) {
        if (this.videoType === 'video_type.vimeo') {
          this.player.setCurrentTime(0)
          this.player.play()
        } else if (this.videoType === 'video_type.youtube') {
          this.bgnTime = 0
          this.player.seekTo(0)
          this.player.playVideo()
        }
      }
    },
    onYoutubeLoaded(data) {
      this.player = data.player
    },
    async initPlayer() {
      const self = this
      if (
        !this.currentComposition ||
        !this.detailLoaded ||
        $(this.$el).find('iframe').length === 0
      ) {
        setTimeout(this.initPlayer, 100)
        return
      }
      this.iframe = $(this.$el)
        .find('iframe')
        .get(0)
      if (!this.videoType) {
        this.videoType = $(this.$el)
          .find('iframe')
          .attr('video-type')
      }
      if (
        this.videoType === 'video_type.youtube' &&
        (!this.player || !this.player.playVideo)
      ) {
        setTimeout(this.initPlayer, 100)
        return
      }
      if (this.videoType === 'video_type.vimeo') {
        this.player = await new Vimeo(this.iframe)

        // 화면 크기 맞춤
        $(this.$el)
          .find('.player-area iframe')
          .removeAttr('width')
        $(this.$el)
          .find('.player-area iframe')
          .removeAttr('height')

        this.$nextTick(async () => {
          const videoWidth = await this.player.getVideoWidth()
          const videoHeight = await this.player.getVideoHeight()

          const frameWidth = $(this.$el)
            .find('.player-area')
            .width()
          $(this.$el)
            .find('.player-area iframe')
            .css('height', 40 + (videoHeight * frameWidth) / videoWidth + 'px')
        })

        this.player.on('play', function(param) {
          self.bgnTime = param.seconds * 1000
          self.endTime = param.seconds * 1000
          self.pt = 0
          self.savePlayHist(true)
        })
        this.player.on('ended', function(param) {
          self.endTime = param.seconds * 1000
          self.pt = param.percent * 100
          self.savePlayHist()
          self.bgnTime = undefined
          self.endTime = undefined
          self.pt = undefined
        })
        this.player.on('pause', function(param) {
          self.endTime = param.seconds * 1000
          self.pt = param.percent * 100
          self.savePlayHist()
          self.bgnTime = undefined
          self.endTime = undefined
          self.pt = undefined
        })
        this.player.on('timeupdate', function(param) {
          if (self.bgnTime === undefined) {
            self.bgnTime = param.seconds * 1000
          }
          self.endTime = param.seconds * 1000
          self.pt = param.percent * 100
          self.savePlayHist()
        })
      } else if (this.videoType === 'video_type.youtube') {
        this.youtubeTimerFunc()
        this.youtubeTimer = setInterval(this.youtubeTimerFunc, 1000)
      }
      if (
        this.currentComposition &&
        this.currentComposition.atnlc &&
        this.currentComposition.atnlc.lastPlayHist &&
        this.currentComposition.atnlc.lastPlayHist.endTime &&
        this.currentComposition.atnlc.lastPlayHist.pt !== 100
      ) {
        this.showModal('playContinueConfirmModalRef')
      } else if (this.player) {
        if (this.videoType === 'video_type.vimeo') {
          this.player.play()
        } else if (this.videoType === 'video_type.youtube') {
          this.player.playVideo()
        }
      }
    },
    youtubeTimerFunc() {
      const video = $(this)
        .find('iframe')
        .contents()
        .find('video')
      $(this)
        .find('iframe')
        .height(
          (video.height() * video.width()) /
            $(this)
              .find('iframe')
              .width()
        )
      const first = !this.bgnTime && !this.endTime && !this.pt

      const seconds = this.player.getCurrentTime()
      const duration = this.player.getDuration()
      if (!this.bgnTime) {
        this.bgnTime = 0
      }
      this.endTime = seconds * 1000
      this.pt = (seconds / duration) * 100
      this.savePlayHist(first)
    },
    savePlayHist(start) {
      if (start) {
        this.playHistId = undefined
      }
      if (!start && !this.playHistId) {
        return
      }
      if (!this.$route.query.goodsCompositionId) {
        return
      }
      let url =
        'atnlc/savePlayHist?goodsCompositionId=' +
        this.$route.query.goodsCompositionId
      if (this.$route.query.atnlcCompositionId) {
        url += '&atnlcCompositionId=' + this.$route.query.atnlcCompositionId
      }
      if (this.playHistId) {
        url += '&playHistId=' + this.playHistId
      }
      if (this.bgnTime !== undefined) {
        url += '&bgnTime=' + Math.floor(this.bgnTime)
      } else {
        url += '&bgnTime=0'
      }
      if (this.endTime !== undefined) {
        url += '&endTime=' + Math.floor(this.endTime)
      }
      if (this.pt !== undefined) {
        url += '&pt=' + this.pt
      }
      url += '&width=' + $(document).width()
      url += '&height=' + $(document).height()
      this.$axios
        .$get(url, {
          no_loading: true,
          progress: false
        })
        .then(response => {
          if (response.resultCode === 'success') {
            if (response.data) {
              this.playHistId = response.data.id
            }
          }
        })
    },
    notLoggedIn() {
      if (Object.keys(this.messages).length === 0) {
        setTimeout(this.notLoggedIn, 50)
        return
      }
      alert(this.$t('common.notification.login_required'))
      window.close()
    }
  }
}
</script>

<style scoped>
.video-content-area {
  opacity: 0;
}
.show-video.video-content-area {
  opacity: 1;
}
</style>
